import { render, staticRenderFns } from "./SportCasinoHolder.vue?vue&type=template&id=0c8666d4&"
import script from "./SportCasinoHolder.vue?vue&type=script&lang=js&"
export * from "./SportCasinoHolder.vue?vue&type=script&lang=js&"
import style0 from "./SportCasinoHolder.vue?vue&type=style&index=0&id=0c8666d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow,VSpacer})
